import React from 'react';
import classnames from 'classnames';
import InlineIcon from '../../inline-icon/inline-icon';
import ArrowRightIcon from '../../../../icons/compiled/components/ArrowRightIcon';
import styles from './button.scss';
const NavButton = _ref => {
  let {
    onClick,
    arrowIcon,
    className,
    ariaLabel,
    dataHook,
    tabIndex,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    style: style,
    type: "button",
    className: classnames(className, styles.button),
    tabIndex: tabIndex,
    "aria-label": ariaLabel,
    "data-hook": dataHook
  }, arrowIcon);
};
NavButton.defaultProps = {
  arrowIcon: /*#__PURE__*/React.createElement(InlineIcon, {
    icon: /*#__PURE__*/React.createElement(ArrowRightIcon, null)
  }),
  tabIndex: 0
};
export default NavButton;
//# sourceMappingURL=button.js.map